import route from "./../index-fill"

export const fetchFormDisplay = async () => {
  const { data } = await route.get(`/builder`)
  console.log(data);
  return data;
}
